export const keycloakConfig = {
  realm: import.meta.env.VITE_KEYCLOAK_REALM || "atica-portal-realm",
  url: import.meta.env.VITE_KEYCLOAK_URL || "https://auth.atica.io",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "react-dev-local",
};

export const appConfig = {
  apiBaseUrl: import.meta.env.VITE_PORTAL_SERVICE_BASE_URL || "",
  environment: import.meta.env.VITE_ENVIRONMENT || "development",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || "",
};

// Stage-only tools: disabled by default, enabled via env var in stage builds.
export const featureFlags = {
  groupPricingRequests:
    import.meta.env.VITE_ENABLE_GROUP_PRICING_REQUESTS === "true",
  notifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === "true",
};
